import React, { useState, useEffect } from "react";
import { useRouteMatch, Switch, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ReportsList from "./ReportsList";
import AccountNotActivate from "../AccountNotActivate/AccountNotActivate";
import { connect } from "react-redux";

const Reports = ({ consultant }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const { path } = useRouteMatch();
  const loaction = useLocation();

  useEffect(() => {
    const { loading, error } = consultant;
    setLoading(loading);
    setError(error);
  }, [consultant]);

  const renderView = () => {
    if (loading) {
      return "Loading ...";
    }
    if (error) {
      return "Error";
    }
    if (consultant.data) {
      return (
        <motion.div className="container-fluid Appointment pb-5">
          {consultant.data && consultant.data.verifiedAt ? (
            <AnimatePresence exitBeforeEnter>
              <Switch location={loaction} key={loaction.pathname}>
                <Route exact path={`${path}`} component={ReportsList} />
                {/* <Route path={`${path}/:child`} component={Child} /> */}
              </Switch>
            </AnimatePresence>
          ) : (
            <AccountNotActivate />
          )}
        </motion.div>
      );
    } else {
      return "";
    }
  };

  return renderView();
};
const mapStateToProps = (state) => {
  return {
    consultant: state.consultant,
  };
};
export default connect(mapStateToProps)(Reports);
